import { KeyboardEventModifier, ScreenSpaceEventType } from "cesium";
import { Observable } from "rxjs";
import { PickConfiguration } from "../../models/event-registration-input";
import { PickOptions } from "../../models/pickOptions.enum";

/* eslint-disable no-magic-numbers */
export enum DtmCesiumLongPressEvents {
    LONG_LEFT_PRESS = 110,
    LONG_RIGHT_PRESS = 111,
    LONG_MIDDLE_PRESS = 112,
    LEFT_CLICK_DRAG = 113,
    RIGHT_CLICK_DRAG = 114,
    MIDDLE_CLICK_DRAG = 115,
}
export const DtmCesiumEvent = { ...ScreenSpaceEventType, ...DtmCesiumLongPressEvents };

export type DtmCesiumEvents = (typeof DtmCesiumEvent)[keyof typeof DtmCesiumEvent];

export interface DtmEventRegistrationInput<EventType = DtmCesiumEvents> {
    event: EventType;
    modifier?: KeyboardEventModifier;
    entityType?: unknown;
    priority?: number;
    pick?: PickOptions;
    pickFilter?: (any: unknown) => boolean;
    pickConfig?: PickConfiguration;
}

export interface DisposableAndPausableObservable<T> extends Observable<T> {
    dispose: () => void;
    isPaused?: boolean;
}
